import { render, staticRenderFns } from "./images-skeleton.vue?vue&type=template&id=97f7a510&scoped=true"
import script from "./images-skeleton.vue?vue&type=script&lang=js"
export * from "./images-skeleton.vue?vue&type=script&lang=js"
import style0 from "./images-skeleton.vue?vue&type=style&index=0&id=97f7a510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f7a510",
  null
  
)

export default component.exports